import { useMemo } from 'react';
import type { CardTemplate } from '@nudge/shared';
import { CATEGORIES } from '@nudge/shared';
import { CategoryAccordion } from './CategoryAccordion';
import { CardTile } from './CardTile';
import { useSettingsStore } from '../../stores/settings';
import { groupTemplatesByCategory, FAVORITES_CATEGORY } from '../../utils/groupTemplatesByCategory';

interface CardGridProps {
  templates: CardTemplate[];
  onPick: (t: CardTemplate) => void;
  onLongPress?: (t: CardTemplate) => void;
}

export function CardGrid({ templates, onPick, onLongPress }: CardGridProps) {
  const cardSize = useSettingsStore((s) => s.settings.card_size);
  const grouped = useMemo(() => groupTemplatesByCategory(templates), [templates]);
  const order = [FAVORITES_CATEGORY, ...Object.keys(CATEGORIES)];
  // large cards need fewer columns; compact and comfortable both fit 3
  const cols = cardSize === 'large' ? 'grid-cols-2' : 'grid-cols-3';

  return (
    <div>
      {order.map((cat) => {
        const arr = grouped.get(cat);
        if (!arr || arr.length === 0) return null;
        return (
          <CategoryAccordion key={cat} categoryKey={cat} count={arr.length} defaultOpen={false}>
            <div className={`grid ${cols} gap-2`}>
              {arr.map((t) => (
                <CardTile
                  key={t.id}
                  template={t}
                  size={cardSize}
                  onClick={() => onPick(t)}
                  onLongPress={onLongPress ? () => onLongPress(t) : undefined}
                />
              ))}
            </div>
          </CategoryAccordion>
        );
      })}
    </div>
  );
}
